// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog (vEdge); the CDN shell opens the service. */
export const serviceScopes = [{ scope: 'External.Raven', category: 'cdn' }] as const;
